'use client';

import { ReactNode } from 'react';
// TODO move LayoutDefault component here, without of 'use client'
import { LayoutDefault as LayoutDefaultComponent } from '@components/layout/Layouts/LayoutDefault';

export default function LayoutDefault({ children, detailModal }: { children: ReactNode, detailModal: ReactNode }) {
  return (
    <LayoutDefaultComponent>
      {children}

      {/* Detail Modal */}
      {detailModal}
    </LayoutDefaultComponent>
  );
}
